import {ModuleConfiguration} from "../router/model/UserPermission";
import {ActionsServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const ActionsModule = new ModuleConfiguration(
    ActionsServiceModuleName,
    [AngularJsMaterialModuleName]);